'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import FloatingBar from './FloatingBar';

const FloatingBarWrapper = () => {
const shouldHideFloatingBar = process.env.NEXT_PUBLIC_FORM_PLATFORM

  if (shouldHideFloatingBar !== "KARETRIP_WEB") {
    return null;
  }

  return <FloatingBar />;
};

export default FloatingBarWrapper;
